import { PhoneOutlined, InstagramOutlined, LinkedinOutlined, PinterestOutlined, MailOutlined, FacebookOutlined } from '@ant-design/icons';
import banner from '../assets/Headerbanner.png'
import { Typography, Button } from 'antd';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

const { Title, Text } = Typography;

const Preview: React.FC = () => {
  const location = useLocation();
  
  useEffect(() => {
    if (location.state?.warning) {
      toast.warning(location.state.warning);
    }
  }, [location]);

    return (
      <div className="min-h-screen bg-white">
        <img
            src={banner}
            alt="مجتمع رنگ عظیمی"
            className="max-w-full object-contain"
          />
        {/* بنر بالایی قرمز */}

  
        {/* توضیحات مرکزی */}
        <div className="text-center px-4 py-6 text-gray-800">
          <Text className="block leading-loose text-lg">
            مجموعه رنگ عظیمی با نیم قرن تجربه در زمینه پخش رنگ، این افتخار را دارد که محصولاتی با کیفیت
            در اختیار مشتریان محترم قرار دهد. از اینکه همراه ما هستید سپاسگزاریم...
          </Text>
        </div>
        {/* دکمه ورود به فروشگاه */}
        <div className="text-center my-8">
            <button
                onClick={() => window.location.href = '/login'}
                className="
                w-72
                py-4
                text-red-600
                font-bold
                text-lg
                rounded-xl
                border-2
                border-red-600
                bg-transparent
                ring-2
                ring-red-500
                hover:bg-red-600
                hover:text-white
                transition-all
                duration-300
                "
            >
                ورود به فروشگاه
            </button>
            </div>
        {/* بخش اطلاعات تماس پایین */}
        <div className="bg-red-600 text-white py-6 px-4 rounded-t-3xl mt-6">
          <div className="max-w-3xl mx-auto text-center space-y-2">
            <Text className="block">آدرس: مازندران، آمل، کیلومتر یک کمربندی هزار به هزار سنگر، مجتمع رنگ عظیمی نیاکی</Text>
            <Text className="block">
              شماره تماس:  ۰۹۰۰۸۲۵۸۰۰۰ - ۰۹۹۰۱۰۵۹۷۲۵ - ۰۱۱۴۴۲۳۵۸۴۶ - ۰۱۱۴۴۲۳۵۸۴۵
            </Text>
            <Text className="block">پست الکترونیکی: info@azimirang.com</Text>
            <div className="flex justify-center gap-6 text-2xl mt-4">
            <a href="tel:09008258000" target="_blank" rel="noopener noreferrer"><PhoneOutlined /></a>
            <a href="#" target="_blank" rel="noopener noreferrer"><InstagramOutlined /></a>
            <a href="#" target="_blank" rel="noopener noreferrer"><PinterestOutlined /></a>
            <a href="#" target="_blank" rel="noopener noreferrer"><LinkedinOutlined /></a>
            <a href="mailto:info@azimirang.com" target="_blank" rel="noopener noreferrer"><MailOutlined /></a>
          </div>
          </div>
        </div>
      </div>
    );
  }

export default Preview;
